import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';


export const LabelsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Label = styled.span`
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  padding: 6px 12px;
  min-height: 32px;
  ${props => `background: ${props.theme.colors.neutrals.grey10}`};
  ${props => `color: ${props.theme.colors.neutrals.grey2}`};
  ${props => (props.theme.isRTL ? 'margin-left' : 'margin-right')}: 8px;
  margin-bottom: 8px;
  svg {
    width: 16px;
    height: 16px;
    ${props => (props.theme.isRTL ? 'margin-left' : 'margin-right')}: 8px;
  }
`;

export const FilterThumbnailsWrapper = styled.div `
  & > div > div:nth-of-type(2) {
    margin-top: 12px;
    cursor: pointer;
    padding-bottom: 20px;
  }
`;

export const ThumbnailLabel = styled(SmallText) `
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
